<template>
  <div class="productDetail">
    <!-- <el-row>
    <el-col :span="16" offset="4" >
    <table  style="width:100%;" border="1px solid #e6e6e6;" cellspacing="0" cellpadding="0" >
      <tbody>
      <tr style="height:50px;">
        <td class="hd" colspan="2" >3.7米X频段地面站</td>
      </tr>
      <tr>
        <th style="width:20%;">产品概述</th>
        <td>3.7米X频段卫星测控数传地面站，主要用于支持商业卫星X频段测控以及卫星数传数据接收</td>
      </tr>
      <tr>
        <th>系统组成</th>
        <td>天伺馈分系统、跟踪设备、信道分系统、终端分系统、时频分系统、监控分系统、保障设备</td>
      </tr>
      <tr>
        <th>系统功能</th>
        <td>
          <li>1.具备X频段接收功能； <br>
         2.具有X左/右圆极化切换功能； <br>
         3.卫星过境时，能够捕获X频段的卫星遥测信号，完成卫星的X频段信号跟踪和遥测接收解调；<br>
         4.具有上行遥控信号发射能力；<br>
         5.具有程序跟踪、手动跟踪、单脉冲自动跟踪、指定位置、待机等多种工作方式；<br>
         6.具有“无人值守”运行管理功能；<br>
         7.具备双通道X频段卫星数传数据的接收、解调和译码功能；<br>
         8.测控体制：支持标准TT&C、扩频TT&C；<br>
         9.数传信号形式；BPSK、QPSK、8PSK等，支持维特比、RS、LDPC等译码。<br>
         </li>
        </td>
      </tr>
      <tr>
        <th>主要指标</th>
        <td>
          <el-descriptions  :column="2" border>
          <el-descriptions-item label="天线口径">3.7米</el-descriptions-item>
          <el-descriptions-item label="座架形式">X/Y轴天线座架结构</el-descriptions-item>
          <el-descriptions-item label="天线运动范围">
            <p>X轴：3°～+177°</p>
            <p>Y轴：3°～+177°</p>
              </el-descriptions-item>
          <el-descriptions-item label="最大速度">
            <p>X轴：≥3.5º/s</p>
            <p>Y轴：≥3.5º/s</p>
          </el-descriptions-item>
          <el-descriptions-item label="最大加速度">
            <p>X轴：≥5°/s2</p>
            <p>Y轴：≥5°/s2</p>
          </el-descriptions-item>
          <el-descriptions-item label="工作频段">
            <p>接收：7.7GHz～9GHz；</p>
            <p>发射7.1GHz～7.3GHz</p>
          </el-descriptions-item>
          <el-descriptions-item label="增益">
            <p>接收：47.0dBi@8200MHz</p>
            <p>发射：45.9dBi@7200MHz</p>
          </el-descriptions-item>
          <el-descriptions-item label="系统G/T值">
            <p>G/T≥25.0dB/K@8200MHz</p>
          </el-descriptions-item>
          <el-descriptions-item label="系统ERIP值">
            <p>≥64dBW@7200MHz</p>
          </el-descriptions-item>
          <el-descriptions-item label="天线第一旁瓣电平">
            <p>≤-14dB</p>
          </el-descriptions-item>
          <el-descriptions-item label="噪声温度">
            <p>≤80K</p>
          </el-descriptions-item>
          <el-descriptions-item label="极化方式">
            <p>接收：左/右旋圆极化同时</p>
            <p>发射：左/右旋圆极化可选，分时</p>
          </el-descriptions-item>
          <el-descriptions-item label="环境适应性">
            <p>工作温度：室外-40℃～+50℃，室内25±5℃</p>
            <p>储存温度：-45℃～+55℃</p>
            <p>相对湿度：2%～98%（25℃）</p>
            <p>抗风：8级风正常工作，12级风不破坏</p>
            <p>供电：220V10%，501Hz；三相380V10%，501Hz，三相不平衡小于5%</p>
            <p>具有防腐蚀、防霉、防潮湿、防雨、防雷电、防鼠咬及防虫蛀等能力</p>
          </el-descriptions-item>


        </el-descriptions>
        </td>
      </tr>
    </tbody>
    </table>

    </el-col>
   </el-row> -->
    <div
      style="height: 300px; position: absolute; left: 10px"
      v-if="this.id != 4 "
    >
      <el-steps direction="vertical" :active="id" style="z-index: 999">
        <el-step
          icon="el-icon-s-help"
          style="z-index: 999; cursor: pointer"
        >
      <template slot='title'>
          <div style="font-size: 12px;" @click="onclick1(0)">3.7米X频段地面站</div>
      </template>

      </el-step>
        <el-step
          icon="el-icon-s-help"
          style="z-index: 999; cursor: pointer"
        >
        <template slot='title'>
          <div style="font-size: 12px;" @click="onclick1(1)">7.3米S/X频段卫星测控数传地面站</div>
      </template>
      </el-step>
        <el-step
          icon="el-icon-s-help"
          style="z-index: 999; cursor: pointer"
        >
        <template slot='title'>
          <div style="font-size: 12px;" @click="onclick1(2)">12米X频段天线卫星地面站</div>
      </template>
      </el-step>
      </el-steps>
    </div>

    <el-row style="margin-top: 50px; margin-bottom: 100px" v-show="id == 0">
      <el-col :span="16" :offset="4">
        <el-descriptions
          direction="vertical"
          :label-style="{
            'text-align': 'center',
            'font-size': '24px',
            color: '#333',
            fontweight: '800',
          }"
          :contentStyle="{ margin: '0', padding: '0' }"
          :column="1"
          border
        >
          <el-descriptions-item label="3.7米X频段地面站" :span="2">
            <el-descriptions
              :labelStyle="{ width: '10%', 'border-left': '0' }"
              :contentStyle="{ 'border-left': '0', 'border-right': '0' }"
              :column="2"
              border
            >
              <el-descriptions-item label="产品概述" :span="2"
                >3.7米X频段卫星测控数传地面站，主要用于支持商业卫星X频段测控以及卫星数传数据接收</el-descriptions-item
              >
              <el-descriptions-item label="系统组成" :span="2"
                >天伺馈分系统、跟踪设备、信道分系统、终端分系统、时频分系统、监控分系统、保障设备</el-descriptions-item
              >
              <el-descriptions-item label="系统功能" :span="2">
                <li>
                  1.具备X频段接收功能； <br />
                  2.具有X左/右圆极化切换功能；<br />
                  3.卫星过境时，能够捕获X频段的卫星遥测信号，完成卫星的X频段信号跟踪和遥测接收解调；<br />
                  4.具有上行遥控信号发射能力；<br />
                  5.具有程序跟踪、手动跟踪、单脉冲自动跟踪、指定位置、待机等多种工作方式；<br />
                  6.具有“无人值守”运行管理功能；<br />
                  7.具备双通道X频段卫星数传数据的接收、解调和译码功能；<br />
                  8.测控体制：支持标准TT&C、扩频TT&C；<br />
                  9.数传信号形式；BPSK、QPSK、8PSK等，支持维特比、RS、LDPC等译码。<br />
                </li>
              </el-descriptions-item>
            </el-descriptions>

            <el-descriptions
              direction="vertical"
              :label-style="{
                'text-align': 'center',
              }"
              :contentStyle="{
                margin: '0',
                padding: '0',
                'border-left': '0',
                'border-right': '0',
              }"
              :column="1"
              border
            >
              <el-descriptions-item label="主要指标" :span="2">
                <el-descriptions
                  :column="2"
                  border
                  :contentStyle="{
                    'border-left': '0',
                    'border-right': '0',
                    'border-top': '0',
                  }"
                >
                  <el-descriptions-item label="天线口径"
                    >3.7米</el-descriptions-item
                  >
                  <el-descriptions-item label="座架形式"
                    >X/Y轴天线座架结构</el-descriptions-item
                  >
                  <el-descriptions-item label="天线运动范围">
                    <p>X轴：3°～+177°</p>
                    <p>Y轴：3°～+177°</p>
                  </el-descriptions-item>
                  <el-descriptions-item label="最大速度">
                    <p>X轴：≥3.5º/s</p>
                    <p>Y轴：≥3.5º/s</p>
                  </el-descriptions-item>
                  <el-descriptions-item label="最大加速度">
                    <p>X轴：≥5°/s2</p>
                    <p>Y轴：≥5°/s2</p>
                  </el-descriptions-item>
                  <el-descriptions-item label="工作频段">
                    <p>接收：7.7GHz～9GHz；</p>
                    <p>发射7.1GHz～7.3GHz</p>
                  </el-descriptions-item>
                  <el-descriptions-item label="增益">
                    <p>接收：47.0dBi@8200MHz</p>
                    <p>发射：45.9dBi@7200MHz</p>
                  </el-descriptions-item>
                  <el-descriptions-item label="系统G/T值">
                    <p>G/T≥25.0dB/K@8200MHz</p>
                  </el-descriptions-item>
                  <el-descriptions-item label="系统ERIP值">
                    <p>≥64dBW@7200MHz</p>
                  </el-descriptions-item>
                  <el-descriptions-item label="天线第一旁瓣电平">
                    <p>≤-14dB</p>
                  </el-descriptions-item>
                  <el-descriptions-item label="噪声温度">
                    <p>≤80K</p>
                  </el-descriptions-item>
                  <el-descriptions-item label="极化方式">
                    <p>接收：左/右旋圆极化同时</p>
                    <p>发射：左/右旋圆极化可选，分时</p>
                  </el-descriptions-item>
                  <el-descriptions-item label="环境适应性">
                    <p>工作温度：室外-40℃～+50℃，室内25±5℃</p>
                    <p>储存温度：-45℃～+55℃</p>
                    <p>相对湿度：2%～98%（25℃）</p>
                    <p>抗风：8级风正常工作，12级风不破坏</p>
                    <p>
                      供电：220V10%，501Hz；三相380V10%，501Hz，三相不平衡小于5%
                    </p>
                    <p>
                      具有防腐蚀、防霉、防潮湿、防雨、防雷电、防鼠咬及防虫蛀等能力
                    </p>
                  </el-descriptions-item>
                </el-descriptions>
              </el-descriptions-item>
              <el-descriptions-item label="图片" :span="2">
                <img style="width: 50%;margin: auto;display: block;" src="../assets/img/11222.png" alt="" />
              </el-descriptions-item>
            </el-descriptions>
          </el-descriptions-item>
        </el-descriptions>
      </el-col>
    </el-row>

    <el-row style="margin-top: 50px; margin-bottom: 100px" v-show="id == 1">
      <el-col :span="16" :offset="4">
        <el-descriptions
          direction="vertical"
          :labelStyle="{
            'text-align': 'center',
            'font-size': '24px',
            color: '#333',
            fontweight: '800',
          }"
          :contentStyle="{ margin: '0', padding: '0' }"
          :column="1"
          border
        >
          <el-descriptions-item
            label="7.3米S/X频段卫星测控数传地面站"
            :span="2"
          >
            <el-descriptions
              :labelStyle="{ width: '10%', 'border-left': '0' }"
              :contentStyle="{ 'border-left': '0', 'border-right': '0' }"
              :column="2"
              border
            >
              <el-descriptions-item label="产品概述" :span="2"
                >7.3米S/X频段卫星测控数传地面站，主要用于支持中低轨卫星S/X频段测控以及卫星遥感数据接收。</el-descriptions-item
              >
              <el-descriptions-item label="系统组成" :span="2"
                >天伺馈跟分系统、信道分系统、基带分系统、监控分系统、时频分系统以及附属设备</el-descriptions-item
              >
              <el-descriptions-item label="系统功能" :span="2">
                系统具有S/X频段标准TT&C、扩频TT&C测控和数传接收功能，具体包括：<br />
                <li>
                  1.采用7.3米S/X频段抛物面天线，具备单脉冲自跟踪、程序跟踪等方式，天线具有测角功能；<br />
                  2.具有标准TT&C及扩频体制的测距、测速功能； <br />
                  3.具有接收、解调S/X频段下行遥测信号能力； <br />
                  4.接收中心遥控指令和注入数据，完成信号调制后以S/X发送； <br />
                  5.具有同时接收两路X频段高速数传数据的能力； <br />
                  6.具有设备远程监控和接收中心任务计划实现自动化运行的能力；<br />
                  按透明方式完成与中心间的数据交换。
                </li>
              </el-descriptions-item>
            </el-descriptions>

            <el-descriptions
              direction="vertical"
              :label-style="{ 'text-align': 'center', border: '0' }"
              :contentStyle="{
                margin: '0',
                padding: '0',
                'border-left': '0',
                'border-right': '0',
              }"
              :column="1"
              border
            >
              <el-descriptions-item label="主要指标" :span="2">
                <el-descriptions
                  :column="2"
                  border
                  :contentStyle="{
                    'border-top': '0',
                    'border-left': '0',
                    'border-right': '0',
                  }"
                >
                  <el-descriptions-item label="工作频段">
                    <p>
                      上行：<br />
                      S 频段：2.025GHz～2.120GHz，步进100Hz；<br />
                      X 频段：7.1GHz～7.3GHz，步进 1kHz；
                    </p>
                    <p>
                      下行：<br />
                      S 频段：2.200GHz～2.300GHz，步进 1kHz； <br />
                      X 频段：7.7GHz～9GHz，步进 1kHz。
                    </p>
                  </el-descriptions-item>
                  <el-descriptions-item label="系统EIRP值">
                    S 频段：EIRP≥58+20lg(F/F0)dBW，F0=2.025GHz； <br />
                    X 频段：EIRP≥70+20lg(F/F0)dBW，F0=7.1GHz。
                  </el-descriptions-item>
                  <el-descriptions-item label="系统G/T值">
                    S 频段：G/T≥18+20lg(F/Fo)dB/K(F0=2.200GHz)； <br />
                    X 频段：G/T≥30+20lg(F/Fo)dB/K(F0=7.7GHz)。
                  </el-descriptions-item>
                  <el-descriptions-item label="极化方式">
                    发射：左/右旋圆极化可选； <br />
                    接收：测控左/右旋圆极化可选，数传可同时工作。
                  </el-descriptions-item>
                  <el-descriptions-item label="天线跟踪性能">
                    <el-table
                      :data="tableData"
                      size="small"
                      border
                      style="width: 100%"
                    >
                      <el-table-column prop="name" label="项目">
                      </el-table-column>
                      <el-table-column prop="content" label="最大工作范围">
                      </el-table-column>
                      <el-table-column prop="fw" label="保精度工作范围">
                      </el-table-column>
                    </el-table>
                  </el-descriptions-item>

                  <el-descriptions-item label="体制">
                    系统具备S/X频段标准TT&C测控、扩频TT&C测控和X频段高速数传的能力
                  </el-descriptions-item>
                  <el-descriptions-item label="速率">
                    (1)遥测：100bps～64kbps； <br />
                    (2)遥控：100bps～20kbps； <br />
                    (3)上行注入：1kbps～1Mbps（数字调制，BPSK 或QPSK）； <br />
                    (4)数传（编码前信息速率）：1Mbps～600Mbps。 <br />
                  </el-descriptions-item>
                  <el-descriptions-item label="遥控、遥测及数传标准">
                    符合 CCSDS、GJB1198-2004、GB/T33987-2017 的
                    BCH、卷积、RS、RS+卷积、LDPC 编码等
                  </el-descriptions-item>
                  <el-descriptions-item label="遥测及数传解调门限(含系统损耗)">
                    (1)标准 TT&C：E/N0 较理论值恶化≤2.5dB； <br />
                    (2)扩频 TT&C：E/N0 较理论值恶化≤2.5dB； <br />
                    (3)数传：E/N0 较理论值恶化≤2.5dB（Pe≤10<sup>-7</sup>）。
                  </el-descriptions-item>
                  <el-descriptions-item label="环境适应性">
                    (1)工作温度：室外-40℃～+50℃，室内25±5℃； <br />
                    (2)储存温度：-45℃～+55℃； <br />
                    (3)相对湿度：2%～98%（25℃）； <br />
                    (4)抗风：8级风正常工作，12级风不破坏； <br />
                    (5)供电：220V±10%，50±1Hz；三相380V±10%，50±1Hz，三相不平衡小于5%；
                    <br />
                    (6)具有防腐蚀、防霉、防潮湿、防雨、防雷电、防鼠咬及防虫蛀等能力。
                  </el-descriptions-item>
                </el-descriptions>
              </el-descriptions-item>
              <el-descriptions-item label="图片" :span="2">
                <img style="width: 50%;margin: auto;display: block;" src="../assets/img/7.2mi.png"  alt="" />
              </el-descriptions-item>
            </el-descriptions>
          </el-descriptions-item>
        </el-descriptions>
      </el-col>
    </el-row>

    <el-row style="margin-top: 50px; margin-bottom: 100px" v-show="id == 2">
      <el-col :span="16" :offset="4">
        <el-descriptions
          direction="vertical"
          :labelStyle="{
            'text-align': 'center',
            'font-size': '24px',
            color: '#333',
            fontweight: '800',
          }"
          :contentStyle="{ margin: '0', padding: '0' }"
          :column="1"
          border
        >
          <el-descriptions-item label="12米X频段天线卫星地面站" :span="2">
            <el-descriptions
              :labelStyle="{ width: '10%', 'border-left': '0' }"
              :contentStyle="{ 'border-left': '0', 'border-right': '0' }"
              :column="2"
              border
            >
              <el-descriptions-item label="产品概述" :span="2"
                >12米X频段卫星地面站，主要用于支持中低轨卫星X频段卫星测控以及高速数传数据接收。</el-descriptions-item
              >
              <el-descriptions-item label="系统组成" :span="2"
                >天伺馈跟分系统、信道分系统、基带分系统、监控分系统、时频分系统、保障分系统</el-descriptions-item
              >
              <el-descriptions-item label="系统功能" :span="2">
                <li>
                  1.跟踪接收功能 <br />
                  2.卫星遥测功能 <br />
                  3.高速数传功能 <br />
                  4.数据记录功能 <br />
                  5.监控管理功能 <br />
                  6.时频统一功能 <br />
                  7.测试标校功能
                </li>
              </el-descriptions-item>
            </el-descriptions>

            <el-descriptions
              direction="vertical"
              :labelStyle="{ 'text-align': 'center', border: '0' }"
              :contentStyle="{
                margin: '0',
                padding: '0',
                'border-left': '0',
                'border-right': '0',
              }"
              :column="1"
              border
            >
              <el-descriptions-item label="系统指标" :span="2">
                <el-descriptions
                  :column="2"
                  border
                  :contentStyle="{
                    'border-top': '0',
                    'border-left': '0',
                    'border-right': '0',
                  }"
                >
                  <el-descriptions-item label="工作频段">
                    上行：7.1GHz～7.3GHz； <br />
                    下行：7.7GHz～9GHz；
                  </el-descriptions-item>
                  <el-descriptions-item label="系统EIRP值">
                    EIRP≥75+20lg(F/F0) dBW，F0=7.1GHz；
                  </el-descriptions-item>
                  <el-descriptions-item label="系统G/T值">
                    G/T≥35+20log(F/F_0)dB/K(F_0=7.75GHz)
                  </el-descriptions-item>

                  <el-descriptions-item label="极化方式">
                    发射：左/右旋圆极化可选； <br />
                    接收：测控左/右旋圆极化可选，数传可同时工作
                  </el-descriptions-item>
                  <el-descriptions-item label="天线跟踪性能">
                    <el-table
                      :data="tableData1"
                      size="small"
                      border
                      style="width: 100%"
                    >
                      <el-table-column prop="name" label="项目">
                      </el-table-column>
                      <el-table-column prop="content" label="最大工作范围">
                      </el-table-column>
                      <!-- <el-table-column prop="fw" label="保精度工作范围">
                      </el-table-column> -->
                    </el-table>
                  </el-descriptions-item>

                  <el-descriptions-item label="体制">
                    具备标准TT&C测控、扩频TT&C测控和高速数传数据接收的能力。
                  </el-descriptions-item>
                  <el-descriptions-item label="速率">
                    ①遥测：100bps～64kbps； <br />
                    ②遥控：100bps～20kbps； <br />
                    ③上行注入：1kbps~1Mbps（数字调制，BPSK 或 QPSK）； <br />
                    ④数传：每通道 <br />
                    BPSK：1M～600Mbps； <br />
                    QPSK,OQPSK,GMSK,UQPSK, UOQPSK：2M～1.2Gbps； <br />
                    8PSK：3M～1.5Gbps； <br />
                    16QAM,16APSK：4M～2Gbps； <br />
                    32APSK：5M～2Gbps；逐比特可调。
                  </el-descriptions-item>
                  <el-descriptions-item label="遥控、遥测及数传标准">
                    符合 CCSDS、GJB1198-2004、GB/T33987-2017 的
                    BCH、卷积、RS、RS+卷积、LDPC 编码等。
                  </el-descriptions-item>
                  <el-descriptions-item label="遥测及数传解调门限(含系统损耗)">
                    ①标准 TT&C：E/N0 较理论值恶化≤2.5dB；（Pe≤10<sup>-5</sup>） <br>
                    ②扩频 TT&C：E/N0 较理论值恶化≤2.5dB；（Pe≤10<sup>-5</sup>） <br>
                    ③数传：E/N0 较理论值恶化≤2.5dB。
                    <br />
                  </el-descriptions-item>
                  <el-descriptions-item label="环境适应性">
                    ①工作温度：室外-40℃～+50℃，室内25±5℃； <br />
                    ②储存温度：-45℃～+55℃； <br />
                    ③相对湿度：2%～98%（25℃）； <br />
                    ④抗风：8级风正常工作，12级风不破坏； <br />
                    ⑤供电：220V10%，501Hz；三相380V10%，501Hz，三相不平衡小于5%；<br />
                    ⑥具有防腐蚀、防霉、防潮湿、防雨、防雷电、防鼠咬及防虫蛀等能力。
                  </el-descriptions-item>
                </el-descriptions>
              </el-descriptions-item>

              <el-descriptions-item label="天伺馈跟指标" :span="2">
                <div style="margin: 10px">
                  (1)天线口径：12米；面精度（RMS）：主面≤0.50mm，副面≤0.30mm；座架结构：方位+俯仰+第三轴；
                  <br />
                  (2)系统3°捕获，5°稳定跟踪并接收数据；X波段跟踪，过顶不丢目标；X波段具有窄带（有信标）和宽带（无信标）跟踪能力；
                  <br />
                  (3)跟踪精度优于1/10半功率波瓣宽度，天线指向精度：＜0.05°
                  <br />
                  (4)天线噪声温度：≤90K（晴空、仰角5度，温度23℃条件下）； <br />
                  (5)天线增益：G≥56.5+20lg（F/F0）dBi（F0=8025MHz，正交器输出口）；<br />
                  (6)第一旁瓣电平：≤-14dB； <br />
                  (7)收发隔离：≥90dB。
                </div>
              </el-descriptions-item>

              <el-descriptions-item label="遥测指标" :span="2">
                <div style="margin: 10px">
                  (1)工作模式：支持标准TT&C测控体制、扩频测控体制，具有通过加载软件实现其它工作模式的能力。
                  <br />
                  (2)输入/出信号中频：70MHz； <br />
                  (3)输入信号AGC控制范围：60dB，控制精度1dB； <br />
                  (4)工作模式切换时间小于2min； <br />
                  (5)遥测误码率1 × 10<sup>-5</sup> 时，接收解调损失≤2.5dB。
                  <!-- (5)遥测误码率1×10<sup>-5</sup> 时，接收解调损失≤2.5dB。 <br /> -->
                </div>
              </el-descriptions-item>

              <el-descriptions-item label="高码率数传终端指标" :span="2">
                <div style="margin: 10px">
                  (1)接收通道:2路； <br />
                  (2)输入信号中频：1200MHz； <br />
                  (3)解调损耗与理论值的偏差（误码率优于1×10<sup>-7</sup>条件下），传输速率5Mbps～600Mbps时：≤1.5dB，传输速率大于600Mbps时：≤3.0dB。
                  <br />
                  (4)载波捕获范围:≥±2MHz； <br />
                  (5)比特同步捕获范围：±0.3％Rs（符号率）；<br />
                  (6)工作模式切换时间：小于1min <br />
                  (7)数据存储转发：具备对数传基带解调数据进行实时存储功能，并支持数据按规定速率通过网络发送。每通道记录速率≥2Gbps，记录误码率优于1×10<sup>-11</sup> 。
                  <br />
                </div>
              </el-descriptions-item>

              <el-descriptions-item label="时频指标" :span="2">
                <div style="margin: 10px">
                  (1)具有GPS/北斗授时系统，能够独立接收GPS/北斗系统授时信息，产生标准的时间码流；
                  <br />
                  (2)能够提供可靠的频率标准信号，产生标准的10MHz频标信号；
                  <br />
                  (3)GPS时间同步精度优于±100ns(RMS)；<br />
                  (4)10MHz频率输出电平：≥13dBm。
                </div>
              </el-descriptions-item>

              <el-descriptions-item label="图片" :span="2">
                <img style="width: 50%;margin: auto;display: block;" src="../assets/img/12mi.png" alt="" />
              </el-descriptions-item>
            </el-descriptions>
          </el-descriptions-item>
        </el-descriptions>
      </el-col>
    </el-row>

    <el-row style="margin-top: 50px; margin-bottom: 100px" v-show="id == 4">
      <el-col :span="16" :offset="4">
        <el-descriptions
          direction="vertical"
          :labelStyle="{
            'text-align': 'center',
            'font-size': '24px',
            color: '#333',
            fontweight: '800',
          }"
          :contentStyle="{ margin: '0', padding: '0' }"
          :column="1"
          border
        >
          <el-descriptions-item label="测运控软件系统" :span="2">
            <el-descriptions
              :labelStyle="{ width: '10%', 'border-left': '0' }"
              :contentStyle="{ 'border-left': '0', 'border-right': '0' }"
              :column="2"
              border
            >
              <el-descriptions-item label="产品概述" :span="2"
                >测运控软件系统是一款基于面向服务、按需定制的一体化云架构测控中心系统，实现收集、处理与发送各种航天测控数据；监视卫星的轨道、姿态及其载其荷的工作状态，并实时发送控制指令；确定卫星的轨道参数，发布轨道预报，显示卫星星下点轨迹；以及对航天测控网中的各个地面测控站进行实时指挥和控制等任务，适用于多星、多目标、多站、多中心、多任务的测运控一体化管控应用场景。</el-descriptions-item
              >
              <el-descriptions-item label="系统组成" :span="2"
                >1.业务运营子系统 <br />
                2.计划调度子系统 <br />
                3.遥测遥控子系统 <br />
                4.飞行动力学子系统 <br />
                5.用户数据分发子系统 <br />
                6.数据存储管理子系统 <br />
                7.综合监控子系统 <br />
                8.综合支撑子系统 <br />
                9.仿真子系统</el-descriptions-item
              >
              <el-descriptions-item label="系统功能" :span="2">
                <li>
                  1.卫星资源管理、用户管理、任务规划与冲突消解、工作计划管理；
                  <br />
                  2.卫星长期遥测监视、遥控发令、卫星轨道确定与预报、卫星平台控制管理；
                  <br />
                  3.用户目标轨道（迹）预报、卫星捕跟控制、用户数据分发、用户卫星在轨管理；
                  <br />
                  4.对整个卫星地面运控系统进行集中监控，开展卫星故障诊断、地面站系统监控、计算机通信系统监控、软件系统监控、综合态势显示、三维可视化显示等；
                  <br />
                  5.汇聚卫星和用户相关数据，完成包括数据存储管理、数据重发、数据事后分发、数据查询、数据分析评估等；<br />
                  6.完成所有用户的信息管理、服务内容发布等。
                </li>
              </el-descriptions-item>
            </el-descriptions>

            <el-descriptions
              direction="vertical"
              :labelStyle="{ 'text-align': 'center', border: '0' }"
              :contentStyle="{ 'border-left': '0', 'border-right': '0' }"
              :column="1"
              border
            >
              <el-descriptions-item label="主要指标" :span="2">
                1.同时并发支持2000颗星的测运控业务 <br />
                2.实时性要求。数据显示刷新时间≤1s，各种操作响应时间：≤1s；
                <br />
                3.单次用户申请需求响应时长≤60s；日计划响应时长≤5min；周计划响应时长≤10min；
                <br />
                4.遥测处理时长不超过一个遥测帧周期；遥控指令加工正确率100%；
                <br />
                5.用户目标GNSS数据定轨精度≤100米； <br />
                6.数据中继存储支持1GB；地面数据存储支持1TB；历史数据查询支持≥30天；
                <br />
                7.激光数据传输速率支持5GB；KA传输速率≥600MB； <br />
                8.支持接入商业航天地面站≥200个； <br />
                9.安全性要求实现故障降级、权限管理。 <br />
                10.扩展性要求支持业务垂直扩展和服务水平扩展。
              </el-descriptions-item>
              <el-descriptions-item label="图片" :span="2">
                <img style="width: 80%;margin: auto;display: block;" src="../assets/img/xitong.png" alt="" />
              </el-descriptions-item>
            </el-descriptions>
          </el-descriptions-item>
        </el-descriptions>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "productDetail",
  data() {
    return {
      id: 8,
      tableData: [
        {
          name: "方位角",
          content: "0°～±355°",
          fw: "0°～±355°",
        },
        {
          name: "俯仰角",
          content: "-1°～181°",
          fw: "5°～70°",
        },
        {
          name: "方位角速度",
          content: "15°/s",
          fw: "0.01°/s～15°/s",
        },
        {
          name: "俯仰角速度",
          content: "10°/s",
          fw: "0.01°/s～10°/s",
        },
      ],
      tableData1: [
        {
          name: "方位角",
          content: "0°～±355°",
          fw: "0°～±355°",
        },
        {
          name: "俯仰角",
          content: "-1°～181°",
          fw: "5°～90°",
        },

        {
          name: "第三轴(7°斜台)",
          content: "-175°～+175°",
          fw: "-170°～+170°",
        },
        {
          name: "方位角速度",
          content: "20°/s",
          fw: "0.01°/s～15°/s",
        },
        {
          name: "俯仰角速度",
          content: "15°/s",
          fw: "0.01°/s～10°/s",
        },
        {
          name: "第三轴速度",
          content: "5°/s",
          fw: "5°/s",
        },
      ],
    };
  },
  watch: {
    $route(to, from) {
      if ((to, from)) {
        this.setheight();
      }
    },
  },
  created() {
    this.id = Number(this.$route.query.id);
  },
  methods: {
    onclick1(e) {
      console.log(e);
      this.id = e;
    },
    imgClick(num) {
      if (num != 1) {
        this.$router.push({ path: "/productDetail", query: { id: num } });
      } else {
        this.$router.push({ path: "/contact", query: { id: num } });
      }
    },
    setheight() {
      var element = 0;
      if (this.$route.query.id == 1) {
        element = this.$refs.outer1;
      } else if (this.$route.query.id == 2) {
        element = this.$refs.outer2;
      } else if (this.$route.query.id == 3) {
        element = this.$refs.outer3;
      } else if (this.$route.query.id == 4) {
        element = this.$refs.outer4;
      } else if (this.$route.query.id == 5) {
        element = this.$refs.outer5;
      }
      if (element) {
        setTimeout(() => {
          const rect = element.getBoundingClientRect();
          const distanceToTop = rect.top + window.scrollY; // 计算距离顶部的距离
          this.$bus.$emit("clearKeyword", distanceToTop);
        }, 500);
      }
    },
  },

  mounted() {
    // this.setheight()
  },
  components: {},
};
</script>
<style lang="scss" scoped>
.productDetail {
  position: relative;
  table {
    width: 100%;
    border-collapse: collapse;

    .hd {
      font-size: 16px;
      line-height: 34px;
      font-weight: 800;
      color: #333;
      background: #fafafa;
      text-align: center;
    }
    th {
      text-align: left;
      font-weight: normal;
      color: #333;
      padding-left: 5%;
    }
    tr {
      height: 100px;
    }
    td {
      padding: 6px 20px;
      font-size: 14px;
      line-height: 24px;

      color: #333;
    }
  }
}
</style>
<style>
.el-step__head:hover {
  color: #67c23a;
  border-color: #67c23a;
}
</style>
